<app-modal-container
  [title]="'Stock ticker'"
  [bigSize]="false"
  [buttons]="modalButtons"
  [applyActivated]="stockMATickerForm?.valid"
  (closeButtonClicked)="close(false)"
  (dismissButtonClicked)="close(false)"
  (applyButtonClicked)="close(true)"
>
  <div [formGroup]="stockMATickerForm" class="vertical-container-simple column-gap-1 width-41">
    <div class="picker selector active centered-column-container">
      <app-input
        data-qa="modal-ticker-search"
        formControlName="tickerName"
        #name
        class="width-100pcnt"
        [autofocus]="true"
        [title]="'Stock ticker'"
        [inputClass]="stockMATickerForm.controls.tickerName.value ? 'uppercase' : ''"
        [placeholder]="stockMATickerForm.controls.tickerName.value ? '' : 'Search for existing or create new ticker'"
        [prefixFirstImgSrc]="'search.svg'"
        [suffixFirstImgSrc]="stockMATickerForm.controls.tickerName.valid ? 'close.svg' : ''"
        [firstSuffixImageTooltip]="'Reset form'"
        (suffixFirstIconEmitter)="resetForm()">
      </app-input>
      <ng-container *ngIf="showFetchedCompaniesFromBackend">
        <div class="picker-dropdown centered-column-container">
          <div class="picker-list centered-column-container">
            <div *ngFor="let ticker of foundTickers" class="width-100pcnt">
              <div class="centered-column-container list-block">
                <div class="list-entry">
                  <div
                    *ngIf="ticker.name"
                    class="start-column-vertically-centered-container width-100pcnt"
                    (click)="selectTickerFromList(ticker)"
                  >
                    <span class="font-3 bold500">{{ticker.symbol}} </span>
                    <span class="font-4 bold500">{{ticker.name}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <span>Industry</span>
    <app-checkbox-selector
      [items]="selectedSectorsArray"
      (itemEmitter)="setFMSSectors($event)">
    </app-checkbox-selector>

    <app-input
      data-qa="modal-ticker-company-name"
      formControlName="companyName"
      [title]="'Company name'">
    </app-input>

    <app-input
        data-qa="modal-ticker-enterpriseValue"
        formControlName="enterpriseValue"
        [title]="'Enterprise value'"
        [thousandSeparator]="','"
        [separator]="'separator.2'"
        [placeholder]="'-'">
    </app-input>

    <app-input
        data-qa="modal-ticker-ratio"
        formControlName="revenueIndex"
        [title]="'EV/Revenue'"
        [thousandSeparator]="','"
        [separator]="'separator.2'"
        [placeholder]="'-'">
    </app-input>

    <app-input
        data-qa="modal-ticker-revenue-ttm"
        formControlName="annualRevenue"
        [title]="'Annual Revenue'"
        [thousandSeparator]="','"
        [separator]="'separator.2'"
        [placeholder]="'-'">
    </app-input>

    <app-input
        data-qa="modal-ticker-revenue-ttm"
        formControlName="revenueGrowth"
        [title]="'Revenue Growth'"
        [thousandSeparator]="','"
        [separator]="'separator.2'"
        [placeholder]="'-'">
    </app-input>

    <app-input
        data-qa="modal-ticker-period"
        formControlName="period"
        [title]="'Last period for MA'"
        [placeholder]="'-'">
    </app-input>
  </div>
</app-modal-container>

